import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import MenuItem from '@zenbusiness/zui/MenuItem';
import Select from '@zenbusiness/zui/Select';

import { orderRow } from '../../utils/proptypes';
import OrderHistoryContainer from '../OrderHistoryContainer';

export default function OrderTemplate({ rows, years, selectedYear, setSelectedYear }) {
  const trackYearFilterChange = useButtonPressedCallback({
    elementName: 'order_year_filter',
    page: 'order_history',
  });

  const handleChange = (e) => {
    trackYearFilterChange(e, { selectedYear: e.target.value });
    setSelectedYear(e.target.value);
  };

  const selectorItems = years.map((year) => <MenuItem key={year} value={year}>{`${year}`}</MenuItem>);

  // Auto-select the most recent year on first render; null signals "not yet chosen"
  useEffect(() => {
    if (years.length > 1 && selectedYear === null) {
      setSelectedYear(years[0]);
    }
  }, [years, selectedYear, setSelectedYear]);

  return (
    <>
      {years.length > 1 && (
        <Box display="flex" justifyContent="flex-start" py={3} pl={4} bgcolor="background.default">
          <Select
            data-testid="select-order-year"
            value={selectedYear ?? ''}
            displayEmpty
            onChange={handleChange}
            inputProps={{ 'aria-label': 'Select Order Years' }}
            sx={{ width: '200px' }}
          >
            <MenuItem value="">
              <em>All Years</em>
            </MenuItem>
            {selectorItems}
          </Select>
        </Box>
      )}
      <OrderHistoryContainer rows={rows} />
    </>
  );
}

OrderTemplate.propTypes = {
  rows: PropTypes.arrayOf(orderRow).isRequired,
  years: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedYear: PropTypes.func.isRequired,
};
